import { render, staticRenderFns } from "./ConversationTemplateIndex.vue?vue&type=template&id=2ec714c1&"
import script from "./ConversationTemplateIndex.vue?vue&type=script&lang=js&"
export * from "./ConversationTemplateIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports